import { RootState } from "../../core/rootReducers";

export function selectPricingsMetadata(state: RootState) {
	return state.metadata.pricingsMetadata;
}

export function selectPricingsGroupingMetadata(state: RootState) {
	return selectPricingsMetadata(state)?.groups?.fields || [];
}
